<div class="row">
    <div class="col-sm-12">
        <core-card [actions]="['expand']">
            <h4 class="card-title">{{titleText | translate}}</h4>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="form-label" for="title">{{'Title' | translate}}</label>
                            <input required type="text" name="title" id="title" class="form-control form-control-sm"
                                [ngClass]="{'is-invalid' : (titleIsInvalid == true)}"
                                placeholder="{{'Title' | translate}}" [(ngModel)]="ticketInput.title" />
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                        <div class="form-group">
                            <label class="form-label" for="customerId">{{'Customer' | translate}}</label>
                            <ng-select [virtualScroll]="true" id="customerId" name="customerId"
                                class="ng-select-size-sm" [items]="customerList" [(ngModel)]="customerId"
                                bindLabel="name" bindValue="id" (change)="getProjectsWithCustomerId()">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="form-label" for="projectId">{{'Project' | translate}}</label>
                            <ng-select [virtualScroll]="true" id="projectId" name="projectId" class="ng-select-size-sm"
                                [ngClass]="{'is-invalid' : (customerProjectIdIsInvalid == true)}" [items]="projectList"
                                [(ngModel)]="ticketInput.customerProjectId" bindLabel="name" bindValue="id">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="form-label" for="priority">{{'Priority' | translate}}</label>
                            <select class="form-control form-control-sm" id="priority" name="priority"
                                [(ngModel)]="ticketInput.priority"
                                [ngClass]="{'is-invalid' : (priorityIsInvalid == true)}">
                                <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                                </option>
                                <option *ngFor="let enumItem of priority | enumKey" [ngValue]="enumItem.key">
                                    {{enumItem.value | translate}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                        <div class="form-group">
                            <label class="form-label" for="ticketTypeId">{{'TicketType' | translate}}</label>
                            <ng-select [virtualScroll]="true" id="ticketTypeId" name="ticketTypeId"
                                class="ng-select-size-sm" [items]="ticketTypeList"
                                [(ngModel)]="ticketInput.ticketTypeId" bindLabel="name" bindValue="id">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-12" *ngIf="token === 'dashboardToken'">
                        <div class="form-group">
                            <label for="carbonCopyList">{{'CarbonCopy' | translate}} </label>
                            <ng-select [virtualScroll]="true" id="carbonCopyList" name="carbonCopyList" [items]="emails"
                                [(ngModel)]="carbonCopies" bindLabel="fullNameAndEmail" [clearSearchOnAdd]="true"
                                [multiple]="true" [closeOnSelect]="false" [hideSelected]="true"
                                [ngClass]="{'is-invalid' : (carbonCopyIsInvalid == true)}">
                            </ng-select>
                        </div>
                    </div>
                    <!-- <div class="col-md-12">
                        <div class="form-group">
                            <label for="blindCarbonCopyList">{{'BlindCarbonCopy' | translate}} </label>
                            <ng-select [virtualScroll]="true" id="blindCarbonCopyList" name="blindCarbonCopyList"
                                [items]="emails" [(ngModel)]="blindCarbonCopies" bindLabel="fullNameAndEmail"
                                [clearSearchOnAdd]="true" [multiple]="true" [closeOnSelect]="false"
                                [hideSelected]="true" [addTag]="addNewCarbonCopy">
                            </ng-select>
                        </div>
                    </div> -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="form-label" for="comment">{{'Comment' | translate}}</label>
                            <input type="file" id="selectedFile" #file1 (change)="upload(file1.files)" />
                            <button id="fileUploadButton" style="font-size: 20px;" [disabled]="isBusy == true" type="button"
                                tooltipClass="fadeInAnimation" placement="top" ngbTooltip="{{'Attach' | translate}}"
                                (click)="openFileUploader()"><i class="fa fa-paperclip"></i></button>
                            <textarea class="form-control form-control-sm" rows="5" placeholder="{{'YorumAciklama' | translate}}"
                                [ngClass]="{'is-invalid' : (commentIsInvalid == true)}"
                                [(ngModel)]="ticketInput.addTicketCommentInput.comment" name="comment"
                                id="comment"></textarea>
                        </div>
                    </div>
                    <div class="table-responsive" *ngIf="ticketInput.addTicketCommentInput.ticketDocuments.length > 0">
                        <table class="table table-sm table-hover">
                            <thead>
                                <tr>
                                    <th class="text-center">{{'Name' | translate}}</th>
                                    <th class="text-center">{{'Actions' | translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of ticketInput.addTicketCommentInput.ticketDocuments">
                                    <td class="text-center">{{item.documentFileName}}</td>
                                    <td class="text-center">
                                        <button [disabled]="isBusy == true" type="button" tooltipClass="fadeInAnimation"
                                            placement="top" ngbTooltip="{{'Delete' | translate}}"
                                            (click)="displayDeleteModal(modalDanger, item)"><i
                                                class="fa fa-trash"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-4">
                        <button type="submit" rippleeffect="" [disabled]="isBusy == true"
                            class="btn btn-success btn-sm mr-1 waves-effect waves-float waves-light"
                            (click)="submit()">{{submitButtonText | translate}}</button>
                    </div>
                </div>
            </div>
        </core-card>
    </div>
</div>
<ng-template #modalDanger let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'Alert' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        {{utility.AlertModalDeleteMessage | translate}}
    </div>
    <div class="modal-footer">
        <button type="submit" rippleeffect="" [disabled]="isBusy == true"
            class="btn btn-danger mr-1 waves-effect waves-float waves-light" (click)="delete()">{{'Delete' |
            translate}}</button>
    </div>
</ng-template>
<app-alert [result]="result"></app-alert>